import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  useTheme,
} from '@mui/material';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  header: {
    '& .MuiCardHeader-action': { marginRight: 0 },
  },
}));

const MainCard = forwardRef(
  (
    {
      border = true,
      boxShadow,
      children,
      content = true,
      contentClass,
      contentSX,
      secondary,
      shadow,
      sx = {},
      title,
      subtitle,
      icon,
      adornment,
      headerSx,
      ...others
    },
    ref
  ) => {
    const theme = useTheme();
    const { classes } = useStyles();
    const darkShadow =
      theme.palette.mode === 'dark'
        ? '0 2px 14px 0 rgb(33 150 243 / 10%)'
        : '0 2px 14px 0 rgb(32 40 45 / 8%)';
    const shadowConfig = shadow && boxShadow ? shadow : darkShadow;

    return (
      <Card
        ref={ref}
        {...others}
        sx={{
          border: border ? '1px solid' : 'none',
          borderColor:
            theme.palette.mode === 'dark'
              ? theme.palette.background.default
              : theme.palette.primary[200] + 75,
          ':hover': {
            boxShadow: boxShadow ? shadowConfig : 'inherit',
          },
          ...sx,
        }}
      >
        {/* card header and action */}
        {title && (
          <CardHeader
            className={classes.header}
            sx={headerSx}
            title={
              <Box display="flex" alignItems="center">
                {icon}
                {title}
                {subtitle && (
                  <Typography
                    variant="body"
                    sx={{ color: theme.palette.grey[400], ml: 0.5 }}
                  >
                    {subtitle}
                  </Typography>
                )}

                {adornment && <Box ml="auto">{adornment}</Box>}
              </Box>
            }
            action={secondary}
          />
        )}

        {title && <Divider />}

        {content && (
          <CardContent sx={contentSX} className={contentClass}>
            {children}
          </CardContent>
        )}
        {!content && children}
      </Card>
    );
  }
);

MainCard.propTypes = {
  border: PropTypes.bool,
  boxShadow: PropTypes.bool,
  children: PropTypes.node,
  content: PropTypes.bool,
  contentClass: PropTypes.string,
  contentSX: PropTypes.object,
  secondary: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.object,
  ]),
  shadow: PropTypes.string,
  sx: PropTypes.object,
  title: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.object,
  ]),
};

export default MainCard;
